import React, { Suspense, lazy, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPlayer from 'react-player';
import { useWindowSize } from 'utils/hooks';
import {
  togglePlayPause,
  setDuration,
  setPlayed,
  setPlayedSeconds,
  setBuffering,
  playSong
} from 'context/player/actions';
import { useStateValue } from 'context/store';

const MobilePage = lazy(() =>
  import(/* webpackChunkName: "MobilePage" */ './Mobile')
);

const DesktopPage = lazy(() =>
  import(/* webpackChunkName: "DesktopPage" */ './Desktop')
);

function Player() {
  const {
    state: { player },
    dispatch
  } = useStateValue();
  const { song, isPlaying, playlist, seeking } = player;

  const play = useRef();

  const { width } = useWindowSize();
  const { pathname } = useLocation();
  const nextSong = song.trackNumber + 1;

  if (width === undefined || width === null) {
    // Wait for the window size
    return <div>{null}</div>;
  }

  function handleWidth() {
    if (width <= 768) {
      return <MobilePage play={play} pathname={pathname} />;
    } else if (width > 768) {
      return <DesktopPage play={play} pathname={pathname} />;
    }
  }

  function handleOnProgress(progress) {
    if (!seeking) {
      dispatch(setPlayed(progress.played));
      dispatch(setPlayedSeconds(progress.playedSeconds));
    }
  }

  function handlePlaySong() {
    if (nextSong < playlist.length) {
      const song = playlist.filter(track => track.trackNumber === nextSong);
      dispatch(playSong(...song));
    } else {
      dispatch(togglePlayPause());
    }
  }

  return (
    <Suspense fallback={<p>{null}</p>}>
      {handleWidth()}
      <ReactPlayer
        ref={play}
        style={{ display: 'none' }}
        url={song.streamUrl}
        playing={isPlaying}
        onReady={() => dispatch(setBuffering(false))}
        onBuffer={() => dispatch(setBuffering(true))}
        onBufferEnd={() => dispatch(setBuffering(false))}
        onEnded={handlePlaySong}
        onProgress={handleOnProgress}
        onDuration={duration => dispatch(setDuration(duration))}
      />
    </Suspense>
  );
}

export default Player;
